import React from "react";
import AdminCard from "./AdminCard";
import type { Admin } from "../AdminsPage";

interface AdminGridProps {
    admins: Admin[];
    loading: boolean;
    onAdminClick: (admin: Admin) => void;
    onActionClick: (admin: Admin, e?: React.MouseEvent) => void;
}

const AdminGrid: React.FC<AdminGridProps> = ({ admins, loading, onAdminClick, onActionClick }) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-20">
                <svg className="animate-spin h-8 w-8 text-[#4f6df5]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" strokeDasharray="30" strokeLinecap="round" />
                </svg>
                <p className="mt-4 text-sm text-gray-500">Obteniendo administradores...</p>
            </div>
        );
    }

    if (admins.length === 0) {
        return (
            <div className="text-center py-20 border-2 border-dashed border-gray-200 bg-gray-50/50 rounded-xl text-gray-500 text-sm">
                No se encontraron administradores para este filtro.
            </div>
        );
    }

    return (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(240px,1fr))] gap-3.5">
            {admins.map((admin) => (
                <AdminCard
                    key={admin.adminId}
                    admin={admin}
                    onAdminClick={onAdminClick}
                    onActionClick={onActionClick}
                />
            ))}
        </div>
    );
};

export default AdminGrid;